// extracted by mini-css-extract-plugin
export default {"col-remove":"columns_col-remove__YCjFL","remove-icon":"columns_remove-icon__JHKab"};